export const token = process.env.REACT_APP_MOODLE_Token;

export const baseURLs = {
  core_course_get_categories: `/webservice/rest/server.php?wstoken=${token}&wsfunction=core_course_get_categories&moodlewsrestformat=json`,
  core_course_get_courses_by_field: `/webservice/rest/server.php?wstoken=${token}&wsfunction=core_course_get_courses_by_field&moodlewsrestformat=json&field=category&value=`,
  core_course_get_contents: `/webservice/rest/server.php?wstoken=${token}&wsfunction=core_course_get_contents&moodlewsrestformat=json&courseid=`,
  Service_for_KB_data: '/mod/kb/appservice_kbws.php?action=updatecontent&courseinstance=',
  Result_post_api: '/api/savetypingResult'
};
